var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xEF\x92\xA2",
    d: "M27.5076 64.9602V77.4525L46.7146 63.0863C47.183 62.774 47.6515 62.4617 48.2761 62.4617H69.9816C74.0416 62.4617 77.477 59.1825 77.477 54.9663V9.99388C77.477 5.93386 74.0416 2.49847 69.9816 2.49847H10.0183C5.80212 2.49847 2.52288 5.93386 2.52288 9.99388V54.9663C2.52288 59.1825 5.80212 62.4617 10.0183 62.4617H25.0091C26.2583 62.4617 27.5076 63.711 27.5076 64.9602ZM10.0183 0H69.9816C75.447 0 79.9754 4.52848 79.9754 9.99388V54.9663C79.9754 60.5879 75.447 64.9602 69.9816 64.9602H48.2761L28.913 79.4826C28.1322 80.1072 27.1953 80.1072 26.2583 79.7949C25.4776 79.3264 25.0091 78.5456 25.0091 77.4525V67.4587V64.9602H22.5106H10.0183C4.39674 64.9602 0.0244141 60.5879 0.0244141 54.9663V9.99388C0.0244141 4.52848 4.39674 0 10.0183 0ZM55.7715 22.1739L35.7838 42.1617C35.3153 42.6301 34.5345 42.6301 34.0661 42.1617L24.0722 32.1678C23.6037 31.6993 23.6037 30.9186 24.0722 30.4501C24.5406 29.9816 25.3214 29.9816 25.7899 30.4501L35.003 39.507L54.0538 20.4562C54.5223 19.9878 55.303 19.9878 55.7715 20.4562C56.24 20.9247 56.24 21.7055 55.7715 22.1739Z",
    fill: "#DBFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessNote);
export default __webpack_public_path__ + "static/media/successNote.78d41b452cb091f230437d519dfa6ab7.svg";
export { ForwardRef as ReactComponent };